import { Link } from 'react-router-dom';

export const Error = () => {
  return (
    <section className='page_404'>
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12 '>
            <div className='col-sm-10 col-sm-offset-1  text-center'>
              <div
                className='four_zero_four_bg'
                style={{ marginLeft: '180px' }}>
                <h1 className='text-center '>404</h1>
              </div>
              <div className='contant_box_404'>
                <h3
                  style={{ marginLeft: '180px' }}
                  className='h2'>
                  Look like you're lost
                </h3>
                <p style={{ marginLeft: '180px' }}>
                  the page you are looking for not available!
                </p>
                <Link
                  to='/'
                  className='link_404'
                  style={{ marginLeft: '180px' }}>
                  Go to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
